var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AdminHeader"},[_c('div',{staticClass:"header-body"},[_vm._m(0),_c('div',{staticClass:"header-right"},[(_vm.walletAddress)?_c('div',{staticClass:"walletShow"},[_vm._v(_vm._s(_vm.showAddress(_vm.walletAddress)))]):_vm._e()])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-left"},[_c('span',[_vm._v("MPC合约参数管理")])])
}]

export { render, staticRenderFns }